
import Tooltip from './Tooltip.vue'
export default {
  components: { Tooltip },
  inheritAttrs: true,
  props: {
    name: {
      required: true,
      type: String
    },
    colors: {
      required: true,
      type: Array
    },
    size: {
      type: Number,
      default: 30
    }
  },
  computed: {
    styles () {
      const styles = {
        borderRadius: `${this.size}px`,
        height: `${this.size}px`,
        width: `${this.size}px`
      }

      if (this.colors.filter(e => typeof e !== 'undefined').length === 1) {
        styles.background = this.colors[0]
      } else {
        styles.background = `linear-gradient( ${this.colors[0]} 50%, ${this.colors[1]} 50%)`
      }

      return styles
    }
  }
}
